import axiosInstance from 'config/axiosConfig';
import {
  POINT_CONVERSION_DECLINE_OPERATION,
  POINT_CONVERSION_VALIDATE_OPERATION,
  POINT_CONVERSIONS_API,
  POINT_CONVERSIONS_API_UPDATE_STATUS
} from 'constants/api';
import { DEFAULT_POINT_CONVERSIONS_SIZE } from 'constants/api/pointConversions';

class PointConversionsApi {
  async getPointConversions() {
    const { data } = await axiosInstance().get(POINT_CONVERSIONS_API, {
      params: {
        ...DEFAULT_POINT_CONVERSIONS_SIZE
      }
    });

    return data;
  }

  async getUncertainPointConversions(offset = 0, size = 100) {
    const { data } = await axiosInstance().get(POINT_CONVERSIONS_API, {
      params: { reconciliationOnly: 1, offset, size }
    });
    return data;
  }
  
  async postPointConversions(dataParam) {
    const { data } = await axiosInstance().post(POINT_CONVERSIONS_API, 
      dataParam
    );

    return data;
  }

  async validatePointConversion(pointConversion) {
    await axiosInstance().put(POINT_CONVERSIONS_API_UPDATE_STATUS, {
      data: [
        {
          id: pointConversion.id,
          operation: pointConversion.operation,
          orderUuid : pointConversion.orderUuid,
          errorCode : pointConversion.errorCode,
          errorMessage : pointConversion.errorMessage
        }
      ]
    });
  }

  async checkHuurayReconciliation(id: number): Promise<{ outcome: 'done' | 'released' | 'pending' | 'unavailable' }> {
    const { data } = await axiosInstance().post(`${POINT_CONVERSIONS_API}/reconciliation/check`, { id });
    return data;
  }

  async resolveHuurayReconciliation(id: number, decision: 'generated' | 'not_generated'): Promise<{ outcome: 'done' | 'released' }> {
    const { data } = await axiosInstance().post(`${POINT_CONVERSIONS_API}/reconciliation/resolve`, { id, decision });
    return data;
  }
}

export default PointConversionsApi;
